module.exports = __webpack_public_path__ + "img/bannerOrange.29b5b706.jpg";